import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Catalog = (props: SvgIconProps) => {
  return (
    <SvgIcon
      fontSize='inherit'
      viewBox='0 0 16 16'
      {...props}
    >
      <path
        d='M4.66667 11.3333H6V10H4.66667V11.3333ZM4.66667 8.66667H6V7.33333H4.66667V8.66667ZM4.66667 6H6V4.66667H4.66667V6ZM7.33333 11.3333H11.3333V10H7.33333V11.3333ZM7.33333 8.66667H11.3333V7.33333H7.33333V8.66667ZM7.33333 6H11.3333V4.66667H7.33333V6ZM2 14V2H14V14H2ZM3.33333 12.6667H12.6667V3.33333H3.33333V12.6667Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};
export default Catalog;
